import { render, staticRenderFns } from "./given.vue?vue&type=template&id=3a3599ea&scoped=true&"
import script from "./given.vue?vue&type=script&lang=js&"
export * from "./given.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3599ea",
  null
  
)

export default component.exports